<template>
  <header class="c-header  h-color--bg" data-color="lightestgrey">
    <div class="c-header__side">
      <transition name="fade">
      <a v-if="$route.meta.showBack && historyLength > 1" @click="goBack" class="o-back h-color--text cursor-pointer" data-color="primary">
          <span class="o-back__icon h-color--text" data-color="primary">
              <Icon icon="back" :auto="true" />
          </span>
        <span class="o-back__text h-uppercase f-b4 f-bold">Back</span>
      </a>
      </transition>
    </div>
    <router-link v-if="site" :to="'/site/'+$route.params.siteId+'/pre-home/'"  class="f-b6 c-header__pubLogo h-uppercase h-color--fill" data-color="black" v-html="site.full_logo"></router-link>
    <h1 v-else class="f-b6 h-uppercase" ></h1><!--v-text="this.$route.name"-->
    <div class="c-header__side c-header__side--right" >
        <a @click="goToBasket()" v-if="!$route.meta.tncPage && $route.meta.hideBasket!==true"  class="o-cart" data-color="primary">
          <IconBasket class="h-color--fill"/>
          <transition name="fade">
            <span v-if="$store.getters.orderItemCount>0" class="o-cart__count f-b4 f-eqLH font-black mt-[.01rem]" v-text="$store.getters.orderItemCount"></span>
          </transition>
          <transition name="fade">
            <span class="o-cart__share f-b4 h-color--text pulse" v-if="$store.getters.sharedBasketItems && $store.getters.sharedBasketItems.basket && $store.getters.sharedBasketItems.basket.length>0 && $store.getters.isAuthed===true" data-color="red">&ast;</span>
          </transition>
        </a>
    </div>
  </header>

</template>

<script>

import IconBasket from "@/components/Icons/IconBasket"
import Icon from '@/components/App/Icon';
import _ from 'underscore';
export default {
    name: 'Header',
    components:{
      IconBasket,
      Icon
    },
    props: ['PageName'],
    mounted() {
      //this.checkForSharedInterval();
      //console.log(this.$store.getters.site);
      if(!_.isObject(this.$store.getters.site) || (_.isObject(this.$store.getters.site) && parseInt(this.$store.getters.site.id)!==parseInt(this.$route.params.siteId)))this.$store.dispatch('getSite');
    },
    computed: {
      site(){
        return this.$store.getters.site;
      },
      currentRouteName() {
        return this.$route.name;
      },
      historyLength(){
        return window.history.length;
      }
    },

    beforeDestroy() {
        clearInterval(this.sharedBasketTO);
    },
    methods: {
      goBack() {
        this.$store.commit('goingBack',true);
        const back = (this.$route.name==='Feedback')?-2:-1
        if(window.history.length > 2){
          this.$router.go(back);
        }else{
             this.$router.push('/site/'+this.$route.params.siteId+'/home');
        }

      },
      goToBasket(){
        if(this.$route.meta.isDiary===true || (this.$route.name==='Menu Product' && this.$route.params.uuid==='diary')) return;
        this.$router.push('/site/'+this.$route.params.siteId+'/basket').catch(()=>{});
      },
      checkForSharedInterval(){
        this.$store.dispatch('getSharedBaskets');
        this.sharedBasketTO = setInterval(()=>{
          this.$store.dispatch('getSharedBaskets');
        },30*1000);
      },
    }
};
</script>
